jQuery(function ($) {
  jQuery(document).ready(function () {
    let data_store = {
      gases: {},
      cages: [],
      customer: {},
    };

    var phoneElement = document.getElementById("info_phone_number");
    var maskOptions = {
      mask: "(000) 000-0000 [Ext. 0000000]",
    };
    var phoneMask = IMask(phoneElement, maskOptions);

    $("input[name='type_of_customer']").on("change", function () {
      if ($(this).val() === "new") {
        $(".customer_number_div").hide();
      } else {
        $(".customer_number_div").show();
      }
    });

    function changePage(page) {
      var formContainer = $(".form-container.active");

      formContainer.removeClass("active");
      $(`.form-container-${page}`).addClass("active");
      scrollFormPage();

      if (page == 3 && hasStep4()) {
        setStep4(true);
      } else {
        setStep4(false);
      }
    }

    function setStep4(enable) {
      // if (enable || true) {
      $(".form-container-3 .btn-next").show();
      $(".form-container-3 .btn-submit").hide();
      // }else {
      //   $(".form-container-3 .btn-next").hide();
      //   $(".form-container-3 .btn-submit").show();
      // }
    }

    // btn-next - "Next" button
    $(".form-container .btn-next").on("click tap", function () {
      var formContainer = $(this).parents(".form-container");
      var page = 0;
      var slugs = [];

      var dataDefault = $("form.form").data("default");

      saveData();

      // step-1
      if (formContainer.hasClass("form-container-1")) {
        page = 2;
        // If we have pre-selected the product
        if ("" !== dataDefault) {
          slugs.push(dataDefault);
          renderForm3(slugs);
          page = 3;
        }
        changePage(page);

        if ($(".form-container-2 .product-container.active").length == 0) {
          $(".form-container-2 .btn-next").prop("disabled", true);
        }
      }

      // step-2
      if (formContainer.hasClass("form-container-2")) {
        var products = $(".form-container-2 .product-container.active");

        if (0 >= products.length) {
          return;
        }

        products.each(function () {
          slugs.push($(this).data("product"));
        });
        renderForm3(slugs);

        changePage(3);
      }

      // step-3
      if (formContainer.hasClass("form-container-3")) {
        changePage(4);
      }
    });

    // btn-prev - "Previous" button
    $(".form-container .btn-prev").on("click tap", function () {
      var formContainer = $(this).parents(".form-container");
      var dataDefault = $("form.form").data("default");

      saveData();

      // step-2
      if (formContainer.hasClass("form-container-2")) {
        changePage(1);
      }

      // step-3
      if (formContainer.hasClass("form-container-3")) {
        if ("" !== dataDefault) {
          changePage(1);
        } else {
          changePage(2);
        }
      }

      // step-4
      if (formContainer.hasClass("form-container-4")) {
        changePage(3);
      }
    });

    // btn-submit - "Place Order" button
    $(".btn-submit").on("click tap", function () {
      saveData();
      $(".form-container-4 .btn-submit").prop("disabled", true);
      $('body').loading_screen( true, function() { } );

      ThemeJS.Functions.send_ajax_request({
        data: {
          action: "new_order_process_order",
          ...data_store,
        },
        success: (response) => {
          // console.log( response );
          window.location = ThemeJS.Variables.Base_Url + "/thank-you";
        },
        error: (response) => {
          $(".form-container-4 .btn-submit").prop("disabled", false);
          $('body').loading_screen( false, function() { } );
        },
      });
    });

    // validate step-1
    var form1InputSelectors =
      '.form-container-1 input[type="text"]:visible, ' +
      '.form-container-1 input[type="tel"]:visible, ' +
      '.form-container-1 input[type="email"]:visible';
    var validateForm1Event = function () {
      var valForm1 = validateForm1();

      if (valForm1.valid) {
        $(".form-container-1 .btn-next").prop("disabled", false);
      } else {
        $(".form-container-1 .btn-next").prop("disabled", true);
      }
    };
    $(form1InputSelectors).on("input", validateForm1Event);
    $('.form-container-1 input[name="type_of_customer"]').on(
      "change",
      validateForm1Event
    );

    $(".form-container-2 .product-container").on("click tap", function () {
      if ($(this).hasClass("active")) {
        $(".order_check", this).removeClass("active");
        $(this).removeClass("active");
      } else {
        $(".order_check", this).addClass("active");
        $(this).addClass("active");
      }
      var products = $(".form-container-2 .product-container.active");
      if (0 < products.length) {
        $(".form-container-2 .btn-next").prop("disabled", false);
      } else {
        $(".form-container-2 .btn-next").prop("disabled", true);
      }
    });

    $(document).on(
      "click tap",
      ".form-container-3.active .btn-add",
      function () {
        var dataNext = parseInt($(this).attr("data-next"));
        var slug = $(this).data("product-slug");
        let $product = $(this).parents(".product-variant");

        $(".body", $product).append(generateEntry(slug, dataNext));

        // renderForm3Entry( dataProduct, dataNext );
        $(this).attr("data-next", dataNext + 1);
      }
    );

    $(document).on(
      "click tap",
      ".form-container-3.active .btn-rmv",
      function () {
        var dataTarget = $(this).data("target");
        $("#" + dataTarget).remove();
      }
    );

    $(document).on("change", ".form-container-3.active .entry-c", function () {
      var dataProduct = $(this).data("product-slug");
      var mix = $(this).val();
      var id = $(this).attr("id");
      var selector = "#" + id.replace("-mix-", "-siz-");

      let sizes = window.gases[dataProduct].variants
        .filter((item) => item.mix === mix)
        .map((el) => {
          return el.size;
        });
        // .filter((item, i, ar) => ar.indexOf(item) === i);

      let sku = window.gases[dataProduct].variants
        .filter((item) => item.mix === mix)
        .map((el) => {
          return el.sku;
        });
        // .filter((item, i, ar) => ar.indexOf(item) === i);

      $(selector).html(
        sizes.map((el, index) => {
          return `<option>${el} (${sku[index]})</option>`;
        })
      );
    });

    $(document).on(
      "change",
      ".form-container-3.active .entry-size-select",
      function () {
        if (hasStep4()) {
          setStep4(true);
        } else {
          setStep4(false);
        }
      }
    );

    function hasStep4() {
      return true;
    }

    // validate step-4
    var form4InputSelectors = ".form-container-4 input.entry-pc";
    var validateForm4Event = function () {
      $(".form-container-4 .btn-submit").prop("disabled", false);
    };
    $(form4InputSelectors).on("input", validateForm4Event);

    function scrollFormPage() {
      $("html, body").animate(
        {
          scrollTop: $(".forms_pages").offset().top,
        },
        250
      );
    }

    function validateForm1() {
      var valid = true;
      var data_post = {};
      $(form1InputSelectors).each(function (i) {
        if ($(this).attr("required") && "" === $(this).val()) {
          // console.log( $( this ).attr( 'name' ) + ' required false' );
          valid = false;
          return true; // continue
        }

        if ($(this).attr("type") == "email") {
          var validRegex =
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!$(this).val().match(validRegex)) {
            // console.log( $( this ).attr( 'name' ) + ' regex false' );
            valid = false;
            return true; // continue
          }
        }

        if ($(this).attr("name") == "info_phone_number") {
          var validRegex = /^\(\d{3}\) \d{3}-\d{4}(\ Ext\.\ \d+)?$/;
          if (!phoneMask.typedValue.match(validRegex)) {
            // console.log( $( this ).attr( 'name' ) + ' regex false' );
            valid = false;
            return true; // continue
          }
        }

        data_post[$(this).attr("name")] = $(this).val();
      });

      return {
        valid: valid,
        data_post: data_post,
      };
    }

    function generateEntry(slug, count, options = false) {
      let html_body = $("template#gas-options-body").html();
      let mix_selected;

      let grade_composition = window.gases[slug].category.grade;
      console.log(window.gases[slug].category, slug, window.gases[slug]);

      let mix = window.gases[slug].variants
        .map((el) => {
          return el.mix;
        })
        .filter((item, i, ar) => ar.indexOf(item) === i);

      mix_selected = options && options.mix ? options.mix : mix[0];

      let sizes = window.gases[slug].variants
        .filter((item) => item.mix === mix_selected)
        .map((el) => {
          return el.size;
        });
        // .filter((item, i, ar) => ar.indexOf(item) === i);

      let sku = window.gases[slug].variants
        .filter((item) => item.mix === mix_selected)
        .map((el) => {
          return el.sku;
        });
        // .filter((item, i, ar) => ar.indexOf(item) === i);

      return html_body
        .replace(
          /{mix_type}/g,
          grade_composition == "yes" ? "Grade" : "Composition"
        )
        .replace(/{entry_id}/g, `entry-${window.gases[slug].id}-${count}`)
        .replace(
          /{mix_name_id}/g,
          `entry-mix-${window.gases[slug].id}-${count}`
        )
        .replace(/{product_id}/g, window.gases[slug].id)
        .replace(/{product_slug}/g, slug)
        .replace(
          /{size_name_id}/g,
          `entry-siz-${window.gases[slug].id}-${count}`
        )
        .replace(
          /{quantity_name_id}/g,
          `entry-qty-${window.gases[slug].id}-${count}`
        )
        .replace(/{qty}/g, options && options.qty ? options.qty : 1)
        .replace(/{mix_show}/g, mix_selected !== "" ? "" : " hide")
        .replace(
          /{mix}/g,
          mix.map((el) => {
            if (options && options.mix == el)
              return `<option selected>${el}</option>`;
            else return `<option>${el}</option>`;
          })
        )
        .replace(
          /{sizes}/g,
          sizes.map((el, index) => {
            if (options && options.size == el)
              return `<option value="${el}" selected>${el} (${sku[index]})</option>`;
            else return `<option value="${el}">${el} (${sku[index]})</option>`;
          })
        );
    }

    function renderForm3(slugs) {
      let html = "";
      let html_core = $("template#gas-options-main").html();
      let body = "";

      for (var i in slugs) {
        // let safety = `<a class="helper-link" href="${
        //   window.gases[slugs[i]].safety
        // }" target="_blank"><i class="fa-solid fa-circle-exclamation"></i> Safety Data Sheet</a>`;

        let category = window.gases[slugs[i]].category.colour
          ? `<span class="category-badge" style="background-color:${
              window.gases[slugs[i]].category.colour
            };color: ${window.gases[slugs[i]].category.text_colour};"> ${
              window.gases[slugs[i]].category.name
            } </span>`
          : `<span class="category-badge"> ${
              window.gases[slugs[i]].category.name
            } </span>`;
        let index = 1;

        body = "";

        if (data_store.gases && data_store.gases[slugs[i]]) {
          for (var t in data_store.gases[slugs[i]]) {
            body += generateEntry(slugs[i], t, data_store.gases[slugs[i]][t]);
            index = t;
          }

          index++;
        } else {
          body = generateEntry(slugs[i], 0);
        }

        html += html_core
          .replace(/{title}/g, window.gases[slugs[i]].name)
          .replace(/{category}/g, category)
          .replace(/{sizeChart}/g, window.gases[slugs[i]].size_chart)
          .replace(/{sds}/g, "")
          .replace(/{id}/g, window.gases[slugs[i]].id)
          .replace(/{index}/g, index)
          .replace(/{product_slug}/g, slugs[i])
          .replace(/{gas-options-body}/g, body);
      }

      $(".form-container-3 .content").html(html);
    }

    function saveData() {
      // Reset data store
      data_store.cages = {};
      data_store.customer = {};
      data_store["g-recaptcha-response"] = document.getElementById(
        "g-recaptcha-response"
      ).value;

      if ($(".form-container-3 .product-variant").length > 0) {
        data_store.gases = {};
        $(".form-container-3 .product-variant").each(function () {
          let slug = $(this).data("product-slug");
          data_store.gases[slug] = [];
          $(".entry", this).each(function () {
            let mix = $(".entry-mix-select", this).val();
            let size = $(".entry-size-select", this).val();
            let qty = $(".entry-qty", this).val();

            size = size.split("(")[0].trim();
            console.log(mix, size, qty)

            data_store.gases[slug].push({
              mix: mix,
              size: size,
              qty: qty,
              sku: window.gases[slug].variants.filter(
                (item) => item.mix === mix && item.size === size
              )[0]["sku"],
            });
          });
        });
      }

      $(
        "[name^=info], [name=type_of_customer]:checked",
        "form#gasOrderForm"
      ).each(function () {
        data_store.customer[$(this).attr("name")] = $(this).val();
      });

      if (hasStep4()) {
        $("[name^=entry-pc]", "form#gasOrderForm").each(function () {
          data_store.cages[$(this).data("sku")] = $(this).val();
        });
      }
    }
  });
});
